"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var StyleButton_1 = require("../style-button/StyleButton");
var theme = require("../../theme.scss");
var INLINE_STYLES = [
    { label: "Bold", style: "BOLD" },
    { label: "Italic", style: "ITALIC" },
    { label: "Underline", style: "UNDERLINE" },
    { label: "Monospace", style: "CODE" },
];
var InlineStyleControls = /** @class */ (function (_super) {
    tslib_1.__extends(InlineStyleControls, _super);
    function InlineStyleControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineStyleControls.prototype.render = function () {
        var _a = this.props, editorState = _a.editorState, onToggle = _a.onToggle;
        var currentStyle = editorState.getCurrentInlineStyle();
        return (React.createElement("div", { className: theme.editorControls }, INLINE_STYLES.map(function (type) {
            return React.createElement(StyleButton_1.default, { key: type.label, active: currentStyle.has(type.style), label: type.label, onToggle: onToggle, style: type.style });
        })));
    };
    return InlineStyleControls;
}(React.Component));
exports.default = InlineStyleControls;
